<template>
  <fade-transition>
    <div class="absolute w-full h-full" v-if="dragging">
      <div class="absolute w-full h-full bg-blue-200 opacity-50"></div>
      <div
        class="text-center absolute flex items-center justify-center text-xl w-full h-full text-blue-800"
      >
        <font-awesome-icon icon="plus-circle" size="lg"></font-awesome-icon>
      </div>
    </div>
  </fade-transition>
</template>

<script>
export default {
  props: {
    dragging: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
